<template>
  <!-- 新建活动 -->
  <el-dialog class="dialog-add-activity" :modal-append-to-body="false" :title="pageType === 'add' ? '新建活动' : '编辑活动'"
    @close="cancel" :visible.sync="dialogVisible" width="1200px">
    <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="16">
          <el-col :span="24">
            <el-form-item label="活动名称 :" prop="text">
              <el-input v-model="form.serviceName" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="活动时间 :" prop="activityTime">
              <el-date-picker class="w-100" v-model="value1" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm"
                :picker-options="pickerOptionsStart" :disabled="pageType === 'detail'" type="datetimerange"
                @change="timeChange" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="活动地点 :" prop="serviceLocation">
              <el-input v-model="form.serviceLocation" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="活动名额 :" prop="quota">
              <el-input v-model.number="form.quota" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="年龄限制 :">
              <div style="display: flex">
                <el-select v-model="form.smallAge" :disabled="pageType === 'detail'" @change="startAgeChange"
                  @clear="setStartAgeList" clearable placeholder="请选择">
                  <el-option v-for="item in startAgeList" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
                <span style="display: inline-block;width:6%;text-align:center"> - </span>
                <el-select v-model="form.bigAge" :disabled="pageType === 'detail'" @change="endAgeChange"
                  @clear="setEndAgeList" clearable placeholder="请选择">
                  <el-option v-for="item in endAgeList" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="报名截止 :" prop="deadlineTime">
              <el-date-picker :disabled="pageType === 'detail'" :picker-options="pickerOptionsEnd"
                v-model="form.deadlineTime" value-format="yyyy-MM-dd HH:mm" type="date"
                placeholder="选择日期时间"></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="活动内容 :" prop="content" :disabled="pageType === 'detail'">
              <cmp-ckeditor ref="myCkeditor1" :readOnly="pageType === 'detail'" :defaultMsg="form.content" :id="`ue1`"
                :height="150"></cmp-ckeditor>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="注意事项 :" prop="attention">
              <cmp-ckeditor ref="myCkeditor2" :readOnly="pageType === 'detail'" :defaultMsg="form.attention" :id="`ue1`"
                :height="150"></cmp-ckeditor>

              <!-- <el-input type="textarea" v-model="form.attention" placeholder="请输入" :disabled="pageType === 'detail'"></el-input> -->
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="联系电话 :" prop="tel">
              <el-input v-model="form.tel" placeholder="请输入" :disabled="pageType === 'detail'"></el-input>
            </el-form-item>
          </el-col>
        </el-col>

        <el-col :span="8">
          <el-form-item class="avatar-uploader-form" label="活动封面 :" prop="mainPic">
            <!-- <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="false" accept=".jpg,.jpeg,.png,.JPG" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="imgUrl" style="height:120px;object-fit:cover;" :src="imgUrl" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传活动封面</div>
              </div>
            </el-upload> -->

            <div class="uploader-form" @click="uploadPicture(1)">
              <img v-if="form.mainPic" :src="form.mainPic" alt="">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
            <div class="tip-img" style="right: 20px">建议图片大小：345 * 184</div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="footer mt-30">
      <el-button @click="cancel">取消</el-button>
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">确定</el-button>
    </div>

    <!-- 剪裁组件弹窗 -->
    <cropper-image ref="cropperRef" @uploadImgSuccess="handleUploadSuccess">
    </cropper-image>
  </el-dialog>
</template>

<script>
import cmpUpload from '@cmp/my-upload/index' //上传组件
import cmpCkeditor from '@cmp/editor/ckeditor'
import CropperImage from "@cmp/cropper";
export default {
  components: { cmpUpload, cmpCkeditor, CropperImage },
  data() {
    const validateFile = (rule, value, callback) => {
      if (!this.form.mainPic) {
        callback(new Error('活动封面不能为空'))
      } else {
        callback()
      }
    }

    const validateTime = (rule, value, callback) => {
      if (!this.form.serviceTimeBegin || !this.form.serviceTimeEnd) {
        callback(new Error('活动时间不能为空'))
      } else {
        callback()
      }
    }

    const validateTel = (rule, value, callback) => {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!this.form.tel) {
        callback(new Error('联系电话不能为空'))
      } else if (!reg.test(this.form.tel)) {
        callback(new Error('请填写正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      loadingSave: false,
      pageType: '', // 页面类型 add 新增 edit 编辑 detail 查看
      detailId: '', // 详情id
      dialogVisible: false,
      value1: [],
      form: {
        serviceTimeBegin: '',
        serviceTimeEnd: '',
        deadlineTime: ''
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          if (this.value1 && this.value1.length > 0) {
            let beginDateVal = this.value1[0]
            if (beginDateVal) {
              return time.getTime() > new Date(beginDateVal).getTime() - 8.64e7
            }
          }
        }
      },

      pickerOptionsStart: {
        disabledDate: time => {
          if (this.form.deadlineTime) {
            return time.getTime() < new Date(this.form.deadlineTime).getTime() + 8.64e7
          }
        }
      },
      imgUrl: '',
      configData: {
        tableName: 'collect'
      },
      startAgeList: [],
      endAgeList: [],
      rules: {
        serviceName: [{ required: true, message: '活动名称不能为空', trigger: 'blur' }],
        activityTime: [{ required: true, validator: validateTime, trigger: 'blur' }],
        serviceLocation: [{ required: true, message: '活动地点不能为空', trigger: 'blur' }],
        quota: [
          { required: true, message: '请输入活动名额', trigger: 'blur' },
          {
            type: 'number',
            message: '名额必须为数字',
            trigger: 'blur',
            transform(value) {
              // 用于解决数字非必填函数。如果没有该函数，该字段会在表单提交时候进行触发（形成必填字段）
              return Number(value)
            }
          }
        ],
        tel: [{ required: true, validator: validateTel, trigger: 'blur' }],
        mainPic: [{ required: true, validator: validateFile, trigger: 'change' }],
      },
    }
  },
  methods: {
    init(type, detailId) {
      this.pageType = type // add 新增 edit 编辑 detail 查看
      this.detailId = detailId || ''
      this.form = {
        serviceType: 1,
        mainPic: '' // 封面id
      }

      this.setAgeList()
      this.$nextTick(() => {
        // this.$refs['form'].resetFields()
        this.$refs['form'].clearValidate()
        this.$refs.myCkeditor1.initEditor()
        this.$refs.myCkeditor2.initEditor()

      })

      this.dialogVisible = true
      if (this.detailId) {
        this.getDetail()
      }
      this.getSelect()
    },

    timeChange(time) {
      if (time) {
        this.form.serviceTimeBegin = time[0]
        this.form.serviceTimeEnd = time[1]
      }
    },

    handleUploadSuccess(result) {
      this.imgUrl = result.attId
      this.form.mainPic = result.attPath
      if (this.form.mainPic) {
        this.$refs['form'].clearValidate(['mainPic'])
      }
      this.cropperModel = false
    },

    //封面设置
    uploadPicture() {
      if (this.pageType == 'detail') {
        return
      }
      this.imgUrl = this.form[`mainPic`]
      let option = {
        cropWidth: "345", cropHeight: "184", imgUrl: this.imgUrl
      }
      this.$refs.cropperRef.initCropper(option)
    },

    startAgeChange(val) {
      this.endAgeList = this.endAgeList.filter(item => {
        return item > val
      })
    },

    endAgeChange(val) {
      this.startAgeList = this.startAgeList.filter(item => {
        return item < val
      })
    },

    setStartAgeList() {
      this.startAgeList = []
      if (this.form.endAge) {
        for (let m = 0; m < this.form.endAge; m++) {
          this.startAgeList.push(m)
        }
      }
    },
    setEndAgeList() {
      this.endAgeList = []
      if (this.form.startAge) {
        for (let m = this.form.startAge + 1; m < 100; m++) {
          this.endAgeList.push(m)
        }
      }
    },
    // 查询下拉框
    getSelect() {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: ['activity_type', 'activity_repeatSet']
        })
        .then(res => {
          if (res.success) {
            var state = res.result
            // let firstArr = [{ dictCode: null, dictName: '全部' }]
            this.typeList = state['activity_type']
            this.repeatList = state['activity_repeatSet']
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 详情
    getDetail() {
      this.$api.volunteer.viewVolunteerRecruit({
        id: this.detailId
      }).then(res => {
        if (res.success) {
          let data = res.result
          this.form = data
          if (this.form.serviceTimeBegin && this.form.serviceTimeEnd) {
            this.value1 = [this.form.serviceTimeBegin, this.form.serviceTimeEnd]
          }
          this.$nextTick(() => {
            this.imgUrl = data.mainPic
          })
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 保存
    fromSubmit(form) {
      let content = this.$refs.myCkeditor1.getContent() // 调用子组件方法
      if (!content) {
        this.$message.info('请输入内容')
        return
      }

      let attention = this.$refs.myCkeditor2.getContent() // 调用子组件方法
      if (!attention) {
        this.$message.info('请输入注意事项')
        return
      }
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          let url = "addVolunteerRecruit"
          if (this.pageType == 'edit') {
            this.form.explainNum = 1
            url = 'editVolunteerRecruit'
          }
          this.$api.volunteer[url]({
            ...this.form,
            content: content,
            attention: attention
          }).then(res => {
            this.loadingSave = false
            if (res.success) {
              if (this.pageType === 'add') {
                this.$message.success('新建社会活动成功')
              } else {
                this.$message.success('编辑社会活动成功')
              }
              this.dialogVisible = false
              this.$emit('refresh')
            } else {
              this.$message.error(res.message)
            }
          })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },

    setAgeList() {
      this.startAgeList = []
      this.endAgeList = []
      for (let m = 0; m < 100; m++) {
        this.startAgeList.push(m)
        this.endAgeList.push(m)
      }
    },

    // 取消
    cancel() {
      this.$refs['form'].resetFields()
      this.imgUrl = ""
      this.value1 = []
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
// .dialog-add-activity {
//   height: 100%;
//   overflow: auto;
// }
.dialog-add-staff {
  /deep/ .el-form-item__error {
    left: 0;
  }
}

/deep/ .el-date-editor {
  width: 100%;
}

.avatar-uploader-form {
  display: flex;
  flex-direction: column;
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }

  .avatar-uploader {
    border: 1px dashed #8c939d;
    height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .el-icon-plus {
      font-size: 20px;
    }

    .el-upload__text {
      line-height: 1;
    }
  }

  .uploader-form {
    width: 345px;
    height: 184px;
    display: flex;
    cursor: pointer;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px dashed #8c939d;
    img {
      width: 100%;
      height: 100%;
    }
    i {
      font-size: 34px;
    }
  }
}
</style>